import { render, staticRenderFns } from "./MiddleKanban.vue?vue&type=template&id=7b55fa12"
import script from "./MiddleKanban.vue?vue&type=script&lang=js"
export * from "./MiddleKanban.vue?vue&type=script&lang=js"
import style0 from "./MiddleKanban.vue?vue&type=style&index=0&id=7b55fa12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports